import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container'
import Navbar from 'react-bootstrap/Navbar'
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import "bootstrap-icons/font/bootstrap-icons.css";
import logo from '../assets/images/logo.png'
import { Link, useNavigate } from 'react-router-dom'
import '../assets/styles/Nav.css'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form'

function Nav(props) {
    const [avatar, setAvatar] = useState("")
    const [username, setUsername] = useState("")
    const [fetchedTradeUrl, setFetchedTradeUrl] = useState("")
    const [tradeUrlModal, tradeUrlModalShow] = useState(false);
    const [settingTradeUrl, setSettingTradeUrl] = useState(false)
    const [tradeUrlSet, isTradeUrlSet] = useState(false)
    const [tradeUrlErrorVisible, setTradeUrlErrorVisible] = useState(false)
    const navigate = useNavigate();

    function handleTradeUrlSubmit() {
        setTradeUrlErrorVisible(false)
        setSettingTradeUrl(true)
        let tradeUrl = document.getElementById('tradeUrlTextArea').value
        fetch('/api/user/setTradeUrl', {
            method: "POST",
            credentials: "include",
            body: JSON.stringify({ tradeUrl }),
            headers: { 'Content-type': 'application/json' }
        })
            .then(res => {
                if(!res.ok){
                    setSettingTradeUrl(false)
                    isTradeUrlSet(false)
                    setTradeUrlErrorVisible(true)
                }else{
                    setSettingTradeUrl(false)
                    isTradeUrlSet(true)
                }
            })
            .catch(error => {
                console.log(error)
                return null
            })
    }

    useEffect(() => {
        if (!props.authenticated) {
            fetch('/api/user/getTradeUrl', {
                method: "GET",
                credentials: "include"
            })
                .then(res => {
                    if (!res.ok) {
                        console.log('Error fetching trade url')
                    } else {
                        return res.json()
                    }
                }).then(data => {
                    if(data && data.tradeUrl){
                        setFetchedTradeUrl(data.tradeUrl)
                    }else{
                        console.log('User has not set a trade url')
                    }
                }).catch(e => {
                    console.log(e)
                })
        }
    }, [])

    useEffect(() => {
        if (!props.authenticated) {
            fetch('/api/user/data', {
                method: "GET",
                credentials: "include"
            })
                .then(res => {
                    if (!res.ok) {
                        console.log('Site requires login')
                    } else {
                        return res.json()
                    }
                }).then(data => {
                    if (data && data.personaname && data.steamid64 && data.avatarfull) {
                        setUsername(data.personaname)
                        props.setSteamId(data.steamid64)
                        setAvatar(data.avatarfull)
                        props.setAuthenticated(true)
                    }
                }).catch(e => {
                    console.log(e)
                })
        }
    }, [])

    function logout() {
        fetch('/api/logout', {
            method: "GET",
            credentials: "include"
        }).then(res => {
            props.setSteamId("")
            setAvatar("")
            setUsername("")
            props.setAuthenticated(false)
            navigate("/")
        })
    }

    function TradeUrlModal(props) {
        return (
            <div className='tradeUrl-modal'>
                <Modal
                    {...props}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    data-bs-theme="dark"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="tradeUrl-modal-title">
                            Set Trade Url
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {tradeUrlSet ?
                            <div className='d-flex justify-content-center align-items-center flex-column'>
                                <span className='tradeurl-setup-complete text-light fw-bold fs-3'>Completed</span>
                                <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                    <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                                    <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                                </svg>
                            </div>
                            :
                            <div>
                                {tradeUrlErrorVisible ?
                                    <span className='fw-bold fs-5 text-danger'>Setting trade url failed. Please retry later.</span>
                                    :
                                    ""
                                }
                                <Form.Control
                                    type='text'
                                    aria-describedby="passwordHelpBlock"
                                    id='tradeUrlTextArea'
                                    required
                                    defaultValue={fetchedTradeUrl}
                                />
                                <Form.Text id="tradeUrlText" muted>
                                    <span className='me-2 '>You can find your steam trade url</span>
                                    <Link to="http://steamcommunity.com/my/tradeoffers/privacy" target="_blank" rel="noopener noreferrer">
                                        here
                                    </Link>
                                </Form.Text>
                            </div>
                        }

                    </Modal.Body>
                    {tradeUrlSet ?
                        ""
                        :
                        <Modal.Footer>
                            {settingTradeUrl ?
                                <span className='tradeUrl-spinner'></span>
                                :
                                <Button id="tradeUrl-btn-submit" variant='outline-success border border-white border-2' onClick={handleTradeUrlSubmit}>Submit</Button>
                            }
                        </Modal.Footer>
                    }
                    
                </Modal>
            </div>

        );
    }



    return (
        <Navbar data-bs-theme="dark">
            <TradeUrlModal
                show={tradeUrlModal}
                onHide={() => tradeUrlModalShow(false)}
            />
            <Container>
                <Navbar.Brand tabIndex={-1} id='navbar-brand' className='fw-bold'>
                    <img className="navbar-logo" src={logo} alt="logo" />SkinFlip
                </Navbar.Brand>
                {props.authenticated ?
                    <div className='text-light ms-auto me-5 fs-5 balance fw-bold border-light border border-3'>
                        <i className="bi bi-wallet2"></i> 1252,3 $
                    </div>
                    :
                    ""
                }
                {props.authenticated ?
                    <DropdownButton
                        as={ButtonGroup}
                        drop={'start'}
                        variant="transparent"
                        id='avatar'
                        style={{ backgroundImage: `url(${avatar})` }}
                        className='me-3 dropdown-btn d-flex align-items-center justify-content-center border border-light border-3 btn'
                    >
                        <Dropdown.Item onClick={logout} className='fw-bold' style={{fontSize:'2em'}} eventKey="1"><i className="bi bi-arrow-bar-right me-2"></i>Logout</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={() => tradeUrlModalShow(true)} className='fw-bold' style={{fontSize:'2em'}} eventKey="2"><i className="bi bi-link-45deg me-2"></i>Set Trade Url</Dropdown.Item>
                    </DropdownButton>
                    :
                    <a href="https://skinflip.pro/api/auth/steam" rel="noopener noreferrer" className="login-btn me-3 fw-bold text-light"><i className="bi bi-steam me-2"></i>Login</a>
                }
            </Container>
        </Navbar>
    );
}

export default Nav